import { v4 as uuidv4 } from 'uuid';

const Italian = [{
    "name": "Bruschetta Tomato Rocksalt",
    "price": [325],
    "isVeg": true,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Broccoli Lemon Aglio Olio",
    "price": [445],
    "isVeg": true,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Twice Baked Cheese Souffle",
    "price": [545],
    "isVeg": false,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Mushroom  Chicken Croustade",
    "price": [545],
    "isVeg": false,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Spiedini Toscana Chicken",
    "price": [545],
    "isVeg": false,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Prawn Aglio Olio New",
    "price": [745],
    "isVeg": false,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Pesto Roasted Chicken Salad",
    "price": [545],
    "isVeg": false,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Spinach Mushroom and Corn Lasagna",
    "price":[599],
    "isVeg": true,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Penne Pesto Tomato",
    "price":[399],
    "isVeg": true,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  },
  {
    "name": "Creamy Risotto",
    "price": [850],
    "isVeg": true,
    "rating": 4.5,
    "type":"Intalian Course",
    "id": uuidv4()
  }
]

export default Italian;